module.exports = __webpack_public_path__ + "static/media/ing.f87a567e.png";